<template>
  <div>
    <div class="row">
      <div class="col-6">
        <distributor-details/>
      </div>
      <div class="col-12">
        <distributor-clients/>
      </div>
    </div>
  </div>
</template>
<script>
import DistributorDetails from './Distributor/DistributorDetails';
import DistributorClients from './Distributor/DistributorClients';

export default {
  components: {
    DistributorDetails,
    DistributorClients,
  },
  methods: {},
  mounted() {
  },
};
</script>
<style></style>
